export function isTextEditingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable || target.closest('[contenteditable]:not([contenteditable="false"]), [role="textbox"]')) return true;
  if (target instanceof HTMLTextAreaElement) return true;
  if (!(target instanceof HTMLInputElement)) return false;

  const nonTextTypes = new Set(['button', 'checkbox', 'color', 'file', 'hidden', 'image', 'radio', 'range', 'reset', 'submit']);
  return !nonTextTypes.has(target.type);
}

export function isCommandPaletteShortcut(event: KeyboardEvent): boolean {
  const hasSinglePlatformModifier = (event.metaKey && !event.ctrlKey) || (event.ctrlKey && !event.metaKey);
  return hasSinglePlatformModifier
    && !event.altKey
    && !event.shiftKey
    && event.key.toLocaleLowerCase() === 'k';
}

export function getCommandShortcutHint(platform: string): '⌘ K' | 'Ctrl K' {
  const normalizedPlatform = platform.toLocaleLowerCase();
  return normalizedPlatform.includes('mac') || normalizedPlatform.includes('iphone') || normalizedPlatform.includes('ipad')
    ? '⌘ K'
    : 'Ctrl K';
}

export function shouldOpenCommandPalette(event: KeyboardEvent): boolean {
  return !event.defaultPrevented
    && !event.isComposing
    && event.keyCode !== 229
    && isCommandPaletteShortcut(event)
    && !isTextEditingTarget(event.target);
}
